export const stringToRegExp = (string: string) => {
    const updatedString = string
        .replace(/([.?+^$[\]\\(){}|-])/g, '\\$1')
        .replace(/\*/g, '.*');
    return new RegExp(updatedString, 'g');
};
